/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import sortTags from 'flarum/tags/common/utils/sortTags';
import type Discussion from 'flarum/common/models/Discussion';
import type Tag from 'flarum/tags/common/models/Tag';

export default function () {
	// We want to remove the background color set by glowingblue/modern-theme
	extend(DiscussionHero.prototype, 'oncreate', function () {
		const { discussion } = this.attrs as { discussion: Discussion };

		const tags = sortTags(discussion.tags() as Tag[]);

		const self = this;

		tags.forEach(function (_tag, i) {
			self.$('.TagLabel').eq(i).attr('style', '');
		});
	});
}
